import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { formatCurrency } from '@/utils/formatters';
import api from '../config/axios';

const loadUserData = async () => {
  try {
    const response = await api.get('/users/me');
    return response.data;
  } catch (error) {
    throw new Error('Não foi possível carregar os dados do usuário');
  }
};

const loadImage = async (url) => {
  try {
    const cleanUrl = url.replace(/^uploads\//, '');
    const fullUrl = `${api.defaults.baseURL}/uploads/${cleanUrl}`;
    
    const response = await fetch(fullUrl);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const blob = await response.blob();
    
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result);
      };
      reader.onerror = (error) => {
        resolve(null);
      };
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    return null;
  }
};

export const generatePDF = async (data) => {
  const { notasFiltradas, totalIRRF, totalISS, totalNotas, totalLiquido } = data;
  
  const userData = await loadUserData();
  
  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a4'
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 10;

  if (userData) {
    if (userData.avatarUrl) {
      try {
        const logoData = await loadImage(userData.avatarUrl);
        if (logoData) {
          doc.addImage(logoData, 'PNG', margin, margin, 40, 20);
        }
      } catch (error) {
      }
    }

    doc.setFontSize(16);
    doc.text(userData.trade_name || 'Prefeitura Municipal', pageWidth / 2, margin + 10, { align: 'center' });
    
    doc.setFontSize(14);
    doc.text('Relatório de Retenção de Impostos', pageWidth / 2, margin + 20, { align: 'center' });
  }

  const tableStartY = margin + 40;
  const tableColumns = [
    { header: 'Fornecedor', dataKey: 'fornecedor' },
    { header: 'Data Emissão', dataKey: 'dataEmissao' },
    { header: 'Nº Nota', dataKey: 'numeroNota' },
    { header: 'Valor Nota', dataKey: 'valorNota' },
    { header: 'IRRF', dataKey: 'valorRetencaoIRRF' },
    { header: 'ISS', dataKey: 'valorRetencaoISS' },
    { header: 'Líquido', dataKey: 'liquidoApagar' }
  ];

  const tableRows = notasFiltradas.map(nota => ({
    fornecedor: nota.fornecedor,
    dataEmissao: new Date(nota.dataEmissao).toLocaleDateString(),
    numeroNota: nota.numeroNota,
    valorNota: formatCurrency(nota.valorNota),
    valorRetencaoIRRF: formatCurrency(nota.valorRetencaoIRRF),
    valorRetencaoISS: formatCurrency(nota.valorRetencaoISS),
    liquidoApagar: formatCurrency(nota.liquidoApagar)
  }));

  doc.autoTable({
    startY: tableStartY,
    head: [tableColumns.map(col => col.header)],
    body: tableRows,
    margin: { top: 10, right: margin, bottom: 10, left: margin },
    columnStyles: {
      0: { cellWidth: 40 },
      1: { cellWidth: 25 },
      2: { cellWidth: 20 },
      3: { cellWidth: 25 },
      4: { cellWidth: 25 },
      5: { cellWidth: 25 },
      6: { cellWidth: 25 }
    },
    styles: {
      fontSize: 8,
      cellPadding: 2,
      overflow: 'linebreak',
      halign: 'left'
    },
    headStyles: {
      fillColor: [66, 66, 66],
      textColor: 255,
      fontSize: 8,
      fontStyle: 'bold'
    },
    didDrawPage: function(data) {
      doc.setFontSize(8);
      doc.text(
        `Página ${doc.internal.getCurrentPageInfo().pageNumber}/${doc.internal.getNumberOfPages()}`,
        pageWidth - margin,
        doc.internal.pageSize.getHeight() - 5,
        { align: 'right' }
      );
    }
  });

  const finalY = doc.lastAutoTable.finalY || doc.internal.pageSize.getHeight() - 30;
  
  doc.setFontSize(10);
  doc.setFont(undefined, 'bold');
  
  const totalsY = finalY + 10;
  doc.text(`Total em Notas: ${formatCurrency(totalNotas)}`, margin, totalsY);
  doc.text(`Total IRRF: ${formatCurrency(totalIRRF)}`, margin + 70, totalsY);
  doc.text(`Total ISS: ${formatCurrency(totalISS)}`, margin + 140, totalsY);
  doc.text(`Total Líquido: ${formatCurrency(totalLiquido)}`, margin, totalsY + 7);

  const pdfData = doc.output('datauristring');
  const printFrame = document.createElement('iframe');
  printFrame.style.display = 'none';
  printFrame.src = pdfData;
  
  document.body.appendChild(printFrame);
  
  printFrame.onload = () => {
    try {
      printFrame.contentWindow.print();
    } catch (error) {
      window.open(pdfData);
    }
    setTimeout(() => {
      document.body.removeChild(printFrame);
    }, 1000);
  };
};

export const generateDOC = (data) => {
  console.log('Gerando DOC:', data);
};
